import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { toast } from "react-toastify";
import Select from "react-select";
import { formatValue } from "react-currency-input-field";

const validationSchema = Yup.object().shape({
  student_id: Yup.object().required("El estudiante es obligatorio"),
  cost_periodic_ids: Yup.object().required("El concepto es obligatorio"),
});

const PeriodicCostCreate = ({ refetchCost, yearFilter }) => {
  const [students, setStudents] = useState([]);
  const [costs, setCosts] = useState([]);
  const currentYear = yearFilter || new Date().getFullYear().toString();

  const { postDataWithParam, getData } = useDataFetch();
  const {
    reset,
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { data: datastudents } = getData(["students"], "/students", {
    enabled: true,
  }, { year: currentYear });

  const { data: datacostperiodics } = getData(
    ["cost-periodics"],
    "/cost-periodics",
    {
      enabled: true,
    }
  );

  const { mutate: createAdmin, isLoading: isPostLoading } = postDataWithParam(
    "/students/assign-cost-periodics",
    {},
    {},
    {
      onSuccess: (data) => {
        refetchCost();
        reset();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const onSubmit = (data) => {
    createAdmin({
      id: data.student_id?.value,
      cost_periodic_ids: [data.cost_periodic_ids?.value],
    });
  };

  useEffect(() => {
    if (datastudents) {
      setStudents([
        ...datastudents?.data.map((e) => ({
          value: e.id,
          label: `${e.identification} - ${e.first_name} ${e.last_name} (${e.level})`,
        })),
      ]);
    }
  }, [datastudents]);

  useEffect(() => {
    if (datacostperiodics) {
      setCosts([
        ...datacostperiodics?.data
          .filter((e) => e.year == currentYear)
          .map((e) => ({
            value: e.id,
            label: `${e.concepts.name} - ${formatValue({
              value: e.value.toString(),
              prefix: '$'
            })} (${e.year})`,
          })),
      ]);
    }
  }, [datacostperiodics]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div
          className={`col-md-6 mb-3 ${
            errors.student_id?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="student_id">Estudiante</label>
          <Controller
            name="student_id"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                options={students}
                defaultValue={null}
                className={errors.student_id ? "is-invalid" : ""}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: 56,
                  }),
                }}
              />
            )}
          />

          {errors.student_id?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.student_id?.message}
            </div>
          ) : null}
        </div>
        <div
          className={`col-md-6 mb-3 ${
            errors.cost_periodic_ids?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="cost_periodic_ids">Concepto</label>
          <Controller
            name="cost_periodic_ids"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                options={costs}
                defaultValue={null}
                className={errors.cost_periodic_ids ? "is-invalid" : ""}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: 56,
                  }),
                }}
              />
            )}
          />

          {errors.cost_periodic_ids?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.cost_periodic_ids?.message}
            </div>
          ) : null}
        </div>
      </div>

      <hr className="mb-4" />
      <button
        className="btn btn-primary btn-lg btn-block"
        type="submit"
        disabled={isPostLoading}
      >
        Guardar
      </button>
    </form>
  );
};

export default PeriodicCostCreate;
